<!--投资机构-->
<template>
  <div class="investment-container">
    <div class="investment-content">
      <div class="investment-search-menu">
        <span>搜索到<span style="color: #fe273b">{{ tablePage.total > 5000 ? '5000+' : tablePage.total }}</span>个结果</span>
        <div class="investment-search-right">
          <el-cascader v-model="region" placeholder="全国" :options="regionItem" @change="changeRegion"
                       :show-all-levels="false" style="width: 120px;margin-right: 10px" clearable></el-cascader>
          <el-date-picker v-model="year" value-format="yyyy" type="year" class="investment-date" placeholder="成立日期"
                          style="width: 140px;margin-right: 10px"/>
          <el-input placeholder="请输入投资机构、企业名称" v-model="keyword" class="keyword-input" style="width: 345px"
                    @keyup.enter.native="getInstitutionsInfo">
            <el-button type="danger" slot="append" @click="getInstitutionsInfo">搜索</el-button>
          </el-input>
        </div>
      </div>
      <div class="investment-table">
        <vxe-table :height="Theight" stripe border align="center" :data="institutionsInfo"
                   :column-config="{resizable: true}"
                   :header-cell-style="{backgroundColor: '#F4F5FD',color: '#333333'}">
          <vxe-column field="investor" title="投资机构">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="enterpriseDetails(row.investorCid)">{{ row.investor }}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="company" title="所属公司">
            <template #default="{ row }">
              <el-link type="primary" :underline="false"  @click="enterpriseDetails(row.investorCid)">{{ row.company }}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="time" title="成立年份" width="120"/>
          <vxe-column field="city" title="地区" width="120"/>
        </vxe-table>
        <div style="padding:10px 10px 0px;">
          <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import cityJsonList from '@/static/city2.json';
import {investmentAgencyList} from '@/api/enterprise_searchApi'
Vue.use(VXETable)
export default {
  name: "investmentInstitutions",
  components: {page},
  data() {
    return {
      region: [],
      regionItem: cityJsonList,
      institutionsInfo: [],
      cityList: {},
      queryAllCityType:0,
      year: '',
      keyword: '',
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      Theight: document.documentElement.clientHeight - 477
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getInstitutionsInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getInstitutionsInfo();
      }
    }
  },
  methods:{
    /*获取投资机构列表*/
    getInstitutionsInfo(){
      investmentAgencyList({
        cityCode: this.region[1],
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        queryAllCityType: this.queryAllCityType,
        stockName: '',
        type: 4,
        year: 0,
        yearName: this.year ? this.year+'年' : ''
      }).then(res=>{
        if (res.code==200){
          this.tablePage.total = parseInt(res.content.total);
          this.institutionsInfo = res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getInstitutionsInfo();
    },
    /*监听地区修改*/
    changeRegion(value){
      if (value[0]==value[1]){
        this.queryAllCityType=0;
      }else if (value[1]==110100 || value[1]==120100 || value[1]==500100 || value[1]==310100){
        this.queryAllCityType=0;
      }else {
        this.queryAllCityType=1;
      }
    },
    /*查看企业详情*/
    enterpriseDetails(id){
      let routeData = this.$router.resolve({
        name: "enterpriseDetails",
        path: '/enterpriseDetails/index',
        query: {id:id}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getInstitutionsInfo();
  },
  beforeMount() {
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
      this.region=[this.cityList.id,this.cityList.vid];
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
          this.region=[li.id,li.vid];
        }
      }
    }
  }
}
</script>
<style scoped>
.investment-container >>> .investment-content .investment-search-menu .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

.investment-container >>> .investment-content .investment-search-menu input::-webkit-input-placeholder {
  color: #999999;

}

.investment-container >>> .investment-content .investment-search-menu .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.investment-container >>> .investment-content .investment-search-menu .el-icon-search {
  font-size: 19px;
}

.investment-container >>> .investment-content .investment-search-menu .el-input-group__append,
.investment-container >>> .investment-content .investment-search-menu .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.investment-container >>> .investment-content .investment-search-menu .investment-date .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
}

.investment-container >>> .investment-content .investment-search-menu .keyword-input .el-input__inner {
  background-color: #ffffff;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 6px 0px 0px 6px;
  border-right: none;
}

.investment-container >>> .investment-content .el-link.el-link--primary {
  color: #1637FF;
}
</style>
<style scoped lang="scss">
.investment-container {
  .investment-content {
    .investment-search-menu {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EBEDF6;
    }

    .investment-table {
      padding: 20px;
    }
  }
}
</style>